export function debounce(fn = () => {}, delay = 300) {
    let timer = null;

    return function() {
        const args = arguments;
        let context = this;

        if (timer) {
            clearTimeout(timer);
        }

        timer = setTimeout(function() {
            fn.apply(context, args);
        }, delay);
    }
};